import { welfareDetailsApi } from 'app/src/services/welfareportal'
import { DefaultBodyType, http, HttpResponse } from 'msw'
import { apiBaseUrl } from './commonconfig'

export const getWelfareDetails = http.get<object, DefaultBodyType, welfareDetailsApi.WelfareDetails>(
  apiBaseUrl + '/DEFAULT/pages/welfareDetails',
  () => {
    return HttpResponse.json({
      title: "L'iniziativa nel dettaglio",
      description:
        'Il programma Welfare 20## è ricco di novità. Di seguito troverati tutte le informazioni necessarie sulle modalità di utilizzo del tuo portafoglio.',
      cards: [
        {
          body: 'L’iniziativa è aperta a tutti i dipendenti non dirigenti in servizio di Poste Italiane S.p.A. e delle Società del Gruppo aderenti.',
          title: 'A chi è rivolto',
          imageSrc: 'images/a_chi_e_rivolto.jpg',
          id: '1',
        },
        {
          body: 'Fino al 10 giugno è aperta la fase di adesione, per scegliere la percentuale del Premio di Risultato da convertire in prodotti e servizi di welfare e vederti riconosciuto il Credito Welfare aggiuntivo.',
          title: 'Come aderire e quando',
          imageSrc: 'images/come_aderire_e_quando.jpg',
          id: '2',
        },
        {
          body: 'Tante le opportunità da scegliere tra le diverse aree di welfare nelle quelli potrai utilizzare il tuo Premio di Risultato convertito: mobilità, cultura, intrattenimento, viaggi e vacanze, sport, previdenza, e molto altro...',
          title: 'Cosa puoi fare?',
          imageSrc: 'images/cosa_puoi_fare.jpg',
          id: '3',
        },
        {
          body: 'Una volta aderito all’iniziativa di welfare aziendale è possibile iniziare ad utilizzare il proprio Conto Welfare. è prevista la modalità di fruizione tramite rimborso, fruizione diretta anche tramite voucher e versamenti.',
          title: 'Modalità e tempistiche',
          imageSrc: 'images/clessidra.png',
          id: '4',
        },
      ],
    })
  },
)

export const welfareDetailsHandlers = [getWelfareDetails]
